import { ErrorBoundary } from 'components/ErrorBoundary';
import { PostCard as PostCardComponent, type Props } from './PostCard';

const PostCardErrorFallback = () => (
  <>
    <div className="bg-[#2c2c2c] rounded-t-md sm:max-w-xs relative min-h-[200px] flex items-center justify-center">
      <div className="text-white text-sm text-center p-4">
        <div className="text-gray-400 mb-2">Unable to load post</div>
        <div className="text-xs text-gray-500">Please refresh the page and contact support@gondola.cc if the problem persists.</div>
      </div>
    </div>
    <div className="bg-[#2c2c2c] rounded-b-md text-white h-[60px]" />
  </>
);

export const PostCard = (props: Props) => (
  <ErrorBoundary componentName="PostCard" fallback={<PostCardErrorFallback />}>
    <PostCardComponent {...props} />
  </ErrorBoundary>
);
